'use strict';

angular.module('utils').factory('OCBannerUtil', function(OCUtil) {
  var self = {
    shouldShowPromoNPRsRemainingBanner: function(clinic) {
      return OCUtil.isPromoClinic(clinic) && clinic.remainingPromoNprs > 0;
    },

    shouldShowBulkMessagingAlert: function(clinic) {
      var reminderDate = _.get(clinic.metadata, 'postCovidBulkMessage.showBulkMessageReminderDate');
      var showReminder = _.get(clinic.metadata, 'postCovidBulkMessage.showBulkMessageReminder') && moment().isAfter(reminderDate);
      var messageSent = _.get(clinic.metadata, 'postCovidBulkMessage.bulkMessageSent');
      var messageSkipped = _.get(clinic.metadata, 'postCovidBulkMessage.bulkMessageSkip');

      if (!clinic.metadata.postCovidBulkMessage || showReminder) {
        return true;
      } else if (messageSent || messageSkipped) {
        return false;
      }
    },
  };
  return self;
});
